import { render, staticRenderFns } from "./CourseTemplate.vue?vue&type=template&id=36e01252&scoped=true&"
import script from "./CourseTemplate.vue?vue&type=script&lang=js&"
export * from "./CourseTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CourseTemplate.vue?vue&type=style&index=0&id=36e01252&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36e01252",
  null
  
)

export default component.exports